import { render, staticRenderFns } from "./Send-Mail-form_visit.vue?vue&type=template&id=26c65814&scoped=true&"
import script from "./Send-Mail-form_visit.vue?vue&type=script&lang=js&"
export * from "./Send-Mail-form_visit.vue?vue&type=script&lang=js&"
import style0 from "./Send-Mail-form_visit.vue?vue&type=style&index=0&id=26c65814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c65814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VCombobox,VContainer,VFlex,VForm,VIcon,VLayout,VTextField})
